import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { useAppSelector } from "src/store";
import { createReminderSubjectSaga } from "src/store/reminder-subjects/saga";
import { getModuleTypes } from "src/store/system/saga";
import { ModuleTypeDto } from "src/store/system/type";
import * as Yup from "yup";

const ReminderSubjectCreateForm = ({
  onHide,
  open,
  onSuccessClick,
}: {
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const languages = useAppSelector((s) => s.language.languages);
  const [moduletypes, setModuleTypes] = useState<ModuleTypeDto[]>([]);
  useEffect(() => {
    open &&
      dispatch(
        getModuleTypes({
          payload: {
            onSuccess: (_m, payload) => setModuleTypes(payload),
            onError: () => {},
          },
        })
      );
  }, [dispatch, open]);

  return (
    <FormDrawer
      drawerProps={{
        isOpen: open,
        onHide: onHide,
        title: t("ReminderSubject.CreateFormTitle").toString(),
      }}
      onHide={onHide}
      loader
      initialValues={{
        ModuleTypeId: "",
        Name: "",
        Translates: languages.map((x) => ({ LanguageId: x.EnumId, Name: "" })),
      }}
      validationSchema={Yup.object().shape({
        Name: Yup.string().required(t("Validation.Required").toString()),
        ModuleTypeId: Yup.number().required(t("Validation.Required").toString()),
        Translates: Yup.array(
          Yup.object({
            Name: Yup.string().required(t("Validation.Required").toString()),
          })
        ),
      })}
      multilanguageinputs={[
        { field: "Name", label: t("ReminderSubject.Name").toString() },
      ]}
      inputs={[
        {
          field: "ModuleTypeId",
          label: t("ReminderSubject.ModuleType").toString(),
          type: "select",
          lookup: { labelKey: "Name", valueKey: "EnumId", options: moduletypes },
        },
      ]}
      onSubmit={(values) => {
        dispatch(
          createReminderSubjectSaga({
            payload: {
              onSuccess: (message) => {
                onHide();
                onSuccessClick(message);
              },
              onError: (message) => toast.error(message, { theme: "colored" }),
            },
            body: values,
          })
        );
      }}
    />
  );
};
export default ReminderSubjectCreateForm;
